import api from '../api'

const baseUrl = '/university/api/AdminCourse'

const moocCourseProvider = {
  getCourse(id) {
    return api.get(`${baseUrl}/Get/${id}`)
  },

  getAllCourseUsers(params = {}) {
    return api.post(`${baseUrl}/PeopleTable`, {
      params,
    })
  },

  getInputs() {
    return api.get(`${baseUrl}/Input`)
  },

  addCourse(params) {
    return api.post(`${baseUrl}/Add`, params)
  },

  getAvailableStatus(params) {
    return api.post(`${baseUrl}/AvailableStatus`, params)
  },

  updateAvailableStatus(params) {
    return api.put(`${baseUrl}/EditStatus`, params)
  },

  updateCourse(params = {}) {
    return api.put(`${baseUrl}/Edit`, params)
  },

  deleteCourse(params) {
    return api.delete(`${baseUrl}/Delete/${params}`)
  },

  addCoursePrerequisite(params) {
    return api.post(`${baseUrl}/CoursePrerequisite`, params)
  },

  searchCoursePrerequisite(params) {
    return api.post(`${baseUrl}/SearchCoursePrerequisite`, params)
  },

  deleteCoursePrerequisite(params = {}) {
    return api.delete(`${baseUrl}/CoursePrerequisite`, { params })
  },

  updateUserRole(params = {}) {
    return api.put(`${baseUrl}/ProductPeopleRole`, params)
  },

  getAdminClassList(params) {
    return api.get(`${baseUrl}/AdminProductPeople/id?id=${params}`)
  },

  generateLoginUrl(params = {}) {
    return api.post(`/academy/api/Home/LoginUrl`, params)
  },

  getTrainUsers(params) {
    return api.get(`${baseUrl}/PracticePeopleTable/id?id=${params}`)
  },

  updateUserTrainScore(params = {}) {
    return api.put(`${baseUrl}/PracticePeopleScore/id`, params)
  },

  setUserScore(params) {
    return api.post(`${baseUrl}/EditScore`, params)
  },
  userLicenseRequest(params) {
    return api.post(`${baseUrl}/LicenseRequest`, params)
  },
}

export default moocCourseProvider
